module.exports = __webpack_public_path__ + "static/media/Senna.eb21d055.png";